import React from 'react';
import { Box } from '@mui/material';

/**
 * Text followed by dots that keep filling up, for the screens that wait for the
 * merchant to open the Visualizador. The dots get a fixed width so the text
 * around them does not move.
 */
export default function WaitingText({ children }) {
    const [dots, setDots] = React.useState(0);

    React.useEffect(() => {
        const id = setInterval(() => setDots((d) => (d + 1) % 4), 450);
        return () => clearInterval(id);
    }, []);

    return (
        <Box component="span" sx={{ display: 'inline-block', whiteSpace: 'nowrap' }}>
            {children}
            <Box component="span" aria-hidden sx={{ display: 'inline-block', width: '1.1em', textAlign: 'left' }}>
                {'.'.repeat(dots)}
            </Box>
        </Box>
    );
}
